const HEX_COLOR =
  /^#([0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/i;

/** Valeur utilisable par `<input type="color">` (#rrggbb). */
export function hexForColorInput(raw, fallback = '#000000') {
  const n = normalizeHexColor(raw);
  if (!n) return fallback;
  if (n.length === 4) {
    const r = n[1];
    const g = n[2];
    const b = n[3];
    return `#${r}${r}${g}${g}${b}${b}`.toLowerCase();
  }
  if (n.length === 5) {
    const r = n[1];
    const g = n[2];
    const b = n[3];
    return `#${r}${r}${g}${g}${b}${b}`.toLowerCase();
  }
  return n.slice(0, 7).toLowerCase();
}

export function normalizeHexColor(raw) {
  if (raw == null) return '';
  let t = String(raw).trim();
  if (!t) return '';
  if (!t.startsWith('#')) t = `#${t}`;
  if (!HEX_COLOR.test(t)) return '';
  return t.toLowerCase();
}
